import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { showPdf } from '../../../shared/helpers/files';

const registrar = async ( params ) => {

  const { 
    idAtencion, tokenAtencion, tipoAtencion, especialidad, 
    fechaDerivacion, cuadroClinico, diagnosticos,
    nivelDerivacion, tipoDerivacion
  } = params;


  if (!idAtencion && !tokenAtencion) {
    console.error('No se recibió el ID de la atención.');
    return null;
  }

  if (!tipoAtencion) {
    console.error('No se recibió el tipo de atencion de derivacion.');
    return null;
  }

  const variblesInit = {
    atenmedId               : idAtencion,
    tokenAtencion           : tokenAtencion,
    atencionDerivacion      : "",
    contrareferencia        : "",
    cuadroClinico           : cuadroClinico || '',
    diagnosticoDerivacion   : diagnosticos || '',
    especialidad            : especialidad,
    esurgente               : "0",
    fechaDerivacion         : fechaDerivacion || '',
    hallazgosDerivacion     : "",
    hispatologia            : "",
    informaciontecnica      : "",
    motivoderivacionId      : "",
    nivelDerivacion         : nivelDerivacion || '',
    procedimientoDerivacion : "",
    tipoAtencion            : tipoAtencion || '',
    tipoderivacionId        : tipoDerivacion || '',
    estadoDerivacion        : "99"
  }


  const query = `
    mutation CrearDerivacion($input: DerivacionInput!) {
      crearDerivacion(input: $input) {
        status
        message
        derivacion {
          id
          token
        }
      }
    }
  `;
  
  const variables = {
    input: {
      ...variblesInit,
    }
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    
    if( response.status !== 200 ) return null;
    const response2 = response.data.data.crearDerivacion;

    const data = response2.derivacion;
    return data;
    
  } catch(error) {
    console.error('Error al registrar derivación:', error);
    return null;
  }

}


const getTiposSelect = async () => {
  const query = `
    query MyQuery {
      allTipoderivacion {
        descripcion
        id
      }
    }
  `;
  try {
    const response = await axios.post(rutas.axios + 'api', { query });

    return response.data.data.allTipoderivacion.map(item => ({
      value: item.id,
      text: item.descripcion,
    }));

  } catch (error) {
    console.log("Error fetching tipos de derivaciones:", error.response.data);
    return error;
  }
}


const getMotivosSelect = async () => {
  const query = `
    query MyQuery {
      allMotivoderivacion {
        descripcion
        id
      }
    }
  `;

  try {
    const response = await axios.post(rutas.axios + 'api', { query });
    // Filtrar los ítems con id 8 y 9
    console.log("response", response.data.data.allMotivoderivacion);
    return response.data.data.allMotivoderivacion
      .filter(item => item.id !== '8' && item.id !== '9')
      .map(item => ({
        value: item.id,
        text: item.descripcion,
      }));

  } catch (error) {
    console.error("Error fetching motivos de derivaciones:", error.response?.data || error.message);
    return error;
  }
}


const getUrlView053 = async (tokenDerivacion, raw = null ) => {

  const query = `
    query MyQuery($tokenDerivacion : String!) {
      generatePdf(tokenDerivacion: $tokenDerivacion) {
        pdfBase64
      }
    }
  `;

  const variables = {
    tokenDerivacion
  }

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if(response.status !== 200 ) return null;

    const response2 = response.data.data.generatePdf;
    if(!response2) return null;

    const dataPdf = response2.pdfBase64;
    if(!dataPdf) return null;

    if(raw)
      return dataPdf;  
    
    const tempUrl = showPdf(dataPdf);
    return tempUrl;

  } catch (error) {
    console.error('error obtener url view 053', error);
  }
}


const completarRegistro = async ( paramVariables ) => {
  if( !paramVariables ) return null;
  const query = `
    mutation ActualizarDerivacion(
      $tokenDerivacion      : String!,
      $tipoderivacionId     : ID,
      $motivoderivacionId   : ID,
      $observacionMotder    : String,
      $fechaDerivacion      : String,
      $nivelDerivacion      : String,
      $especialidad         : ID,
      $hallazgosDerivacion  : String,
      $diagnosticos         : String,
      $laboratorios         : String,
      $imagenes             : String,
      $estadoDerivacion     : String,
      $procedimientos       : String,
      $atenciones           : String,
      $contrareferencia     : String,
      $informaciontecnica   : String,
      $hispatologia         : String,
      $tipoAtencion         : String,
      $esUrgente            : String,
      $cuadroClinico        : String,
      $observacion          : String
    ) {
      actualizarDerivacion(
        tokenDerivacion       : $tokenDerivacion
        observacionMotder     : $observacionMotder
        tipoderivacionId      : $tipoderivacionId
        motivoderivacionId    : $motivoderivacionId
        fechaDerivacion       : $fechaDerivacion
        nivelDerivacion       : $nivelDerivacion
        especialidad          : $especialidad
        hallazgosDerivacion   : $hallazgosDerivacion
        diagnosticoDerivacion : $diagnosticos
        laboratoriosDerivacion : $laboratorios
        imagenesDerivacion    : $imagenes
        estadoDerivacion      : $estadoDerivacion
        procedimientoDerivacion: $procedimientos
        atencionDerivacion    : $atenciones
        contrareferencia      : $contrareferencia
        informaciontecnica    : $informaciontecnica
        hispatologia          : $hispatologia
        tipoAtencion          : $tipoAtencion
        esurgente             : $esUrgente
        cuadroClinico         : $cuadroClinico
        observacion           : $observacion
      ) {
        derivacion {
          id
          token
        }
        status
        message
      }
    }
  `;

  const variables = {
    ...paramVariables
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200 ) return null;
    const data = response.data.data.actualizarDerivacion;
    return data;
    
  } catch(error) {
    console.log(error);
    return error;
  }
}


const deleteRegistro = async ( tokenDerivacion ) => {

  if( !tokenDerivacion ) return null;

  const query = `
    mutation ActualizarDerivacion(
      $tokenDerivacion      : String!,
      $estado               : String
    ) {
      actualizarDerivacion(
        tokenDerivacion       : $tokenDerivacion
        estado                : $estado
      ) {
        derivacion {
          id
          token
        }
        status
        message
      }
    }
  `;


  const variables = {
    tokenDerivacion,
    estado:"0"
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200 ) return null;
    const data = response.data.data.actualizarDerivacion;
    return data;
    
  } catch(error) {
    console.log(error);
    return error;
  }
}


const getByToken = async ( tokenDerivacion ) => {
  
  if( !tokenDerivacion ) return null;
  const query = `
    query GetDerivacionByToken($tokenDerivacion:String!) {
      allDerivacionesenviadas(tokenDerivacion: $tokenDerivacion) {
        message
        status
        total
        derivaciones {
          id
          token
          cuadroClinico
          fechaDerivacion
          nivelDerivacion
          observacion
          hallazgosDerivacion
          diagnosticoDerivacion
          imagenesDerivacion
          observacionMotder
          laboratoriosDerivacion
          procedimientoDerivacion
          atencionDerivacion
          contrareferencia
          informaciontecnica
          hispatologia
          estadoDerivacion
          tipoAtencion
          esurgente
          estado
          obsNegacion
          urlTirillaDerivacion
          atenmedId {
            id
            cita {
              id
              paciente {
                persona {
                  identificacion
                  primerApellido
                  segundoApellido
                  primerNombre
                  segundoNombre
                }
              }
            }
            diaganamSet {
              diagnostico {
                codigo
                descripcion
                id
              }
              esprincipal
              tipoDiagnostico {
                descripcion
                id
              }
            }
            anamnesisSet {
              problemaActual
              obsadicionalAp
            }
            anteperanamSet {
              anio
              descripcionGeneral
              antescedentesPersonales {
                descripcion
                tipoAntecedente
              }
            }
          }
          tipoderivacionId {
            id
            descripcion
          }
          motivoderivacionId {
            id
            descripcion
          }
          especialidad {
            id
            descripcion
            codEsp
          }
        }
      }
    } 
  `;
  const variables = {  tokenDerivacion }

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables } );
    if( response.status !== 200 ) return null;
    const response2 = response.data.data.allDerivacionesenviadas;
    if( response2.status !== "Success" ) return null;

    const data = response2.derivaciones[0];
    return data;

  } catch(error){
    console.log('Error al obtener la derivacion', error);
    return error
  }
}


const getAll = async (params = {}) => {
  const query = `
    query MyQuery( 
      $tokenCita         : String,
      $estadoDerivacion : String, 
      $excel            : String, 
      $page             : Int , 
      $pageSize         : Int, 
      $search           : String,
      $doctorId         : String,
      $idPaciente       : ID,
      $establecimiento  : String,
      $tipoServicio     : String,
      $fechaDesde       : String,
      $fechaHasta       : String
    ) { 
      allDerivacionesenviadas( 
        tokenCita        : $tokenCita,
        estadoderivacion : $estadoDerivacion, 
        excel            : $excel, 
        page             : $page, 
        pageSize         : $pageSize, 
        search           : $search,
        doctorId         : $doctorId,
        idPaciente       : $idPaciente,
        establecimiento  : $establecimiento,
        tipoServicio     : $tipoServicio,
        fechaDesde       : $fechaDesde,
        fechaHasta       : $fechaHasta
      ) {
        message
        status
        total

        dataarchivo
        derivaciones {
          id
          token
          observacion
          tipoAtencion
          especialidad{
            id
            descripcion
          }
          atenmedId {
            cita {
              fechaCita
              cobSeleccionada {
                descripcion
                id
              }
              paciente {
                persona {
                  identificacion
                  primerNombre
                  primerApellido
                }
              }               
              doctor {
                idPersona {
                  primerNombre
                  primerApellido
                }
                especialidad {
                  descripcion
                }
              }
              establecimiento {
                Descripcion
              }
            }
          }
          motivoderivacionId {
            descripcion
          }
          fechaDerivacion
          tipoderivacionId{
            id
            descripcion
          }
          fechaCambio
          estadoDerivacion

        }
      }
    }
  `;

  const variables = {
    ...params
  }

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables }); 
    if( response.status !== 200 ) return null;

    const response2 = response.data.data.allDerivacionesenviadas;
    if( response2.status !== "Success" ) return null;

    return response2;

  } catch (error) {
    console.log("Error fetching derivaciones:", error);
    return error;
  }
}


export const derivacionesService = {
  registrar,
  completarRegistro,
  getTiposSelect,
  getMotivosSelect,
  getUrlView053,
  getByToken,
  getAll,
  deleteRegistro
}